import format from "date-fns/format"
import { enUS, ru, frCH, de, es } from "date-fns/locale"

import type { LanguageISO } from "@providers"

const LOCALES = { en: enUS, ru, fr: frCH, de, es }

export function dateFormater(
  date: Date | number,
  formatStr: string,
  locale: LanguageISO,
) {
  return format(date, formatStr, {
    locale: LOCALES[locale] ?? LOCALES["en"],
  })
}
